<template>
    <div>
        <header>
            <div class="banner">
                <van-row>
                    <van-col span="4" @click="back"><img class="back-icon" :src="require(`@/assets/theme/${theme}/status/01dailyActive/01back.svg`)"></van-col>
                    <van-col span="16">
                        <div class="banner-title">{{ $t('newMonthHistory.title') }}</div>
                    </van-col>
                </van-row>
            </div>
        </header>
        <div class="content">
            <div class="month-box" v-for="item in menu">
                <div class="month-text">{{item.year}}</div>
                <div class="week-box">
                    <div class="week"
                         v-for="month in item.monthArr"
                         v-if="new Date(month.date) < today && new Date(month.date) > startMonth"
                         @click="toMonthDesc(month.date)"
                    >
                        {{month.month}}
                        <img class="to-icon" :src="require(`@/assets/theme/${theme}/status/01dailyActive/06to.svg`)">
                    </div>
                </div>
            </div>
            <div class="no-tag">{{ $t('newMonthHistory.no') }}</div>
        </div>
    </div>
</template>


<script>
    import {GetMonth} from '@/utils/dateUtils'
    import {getQueryVariable} from '@/utils/comment'
    export default {

        data() {
            return {
                theme: 'light',
                startMonth: new Date('2023-07-01'),
                endMonth: new Date(),
                today: new Date(GetMonth(0)),
                menu: [],
            }
        },
        mounted() {
            this.theme = this.$route.query.theme ? this.$route.query.theme : 'light';
            this.initDate();
        },
        methods: {
            back() {
                this.$router.push({
                    name: 'newSportList',
                    query: {
                        lang: this.$i18n.locale,
                        theme: this.theme
                    }
                })
            },
            initDate() {
                let startYear = this.startMonth.getFullYear();
                let endYear = this.endMonth.getFullYear();
                let yearCount = endYear - startYear;
                let menu = [];
                for (let i = 0; i <= yearCount; i++) {
                    let y = startYear + i;
                    menu.push({
                        year: startYear + i,
                        monthArr: [
                            {
                                month: this.$t('monthArr[11]'),
                                date: y + '-12'
                            }, {
                                month: this.$t('monthArr[10]'),
                                date: y + '-11'
                            }, {
                                month: this.$t('monthArr[9]'),
                                date: y + '-10'
                            }, {
                                month: this.$t('monthArr[8]'),
                                date: y + '-09'
                            }, {
                                month: this.$t('monthArr[7]'),
                                date: y + '-08'
                            }, {
                                month: this.$t('monthArr[6]'),
                                date: y + '-07'
                            }, {
                                month: this.$t('monthArr[5]'),
                                date: y + '-06'
                            }, {
                                month: this.$t('monthArr[4]'),
                                date: y + '-05'
                            }, {
                                month: this.$t('monthArr[3]'),
                                date: y + '-04'
                            }, {
                                month: this.$t('monthArr[2]'),
                                date: y + '-03'
                            }, {
                                month: this.$t('monthArr[1]'),
                                date: y + '-02'
                            }, {
                                month: this.$t('monthArr[0]'),
                                date: y + '-01'
                            }
                        ]
                    })
                }
                this.menu = menu.reverse();
            },
            toMonthDesc(month) {
                this.$router.push({
                    name: 'newMonth',
                    query: {
                        month,
                        lang: this.$i18n.locale,
                        theme: this.theme
                    }
                })
            }
        }
    }
</script>

<style scoped>

.month-text {
    font-size: 14px;
    margin-left: 35px;
    margin-bottom: 15px;
    color: var(--text-color-1);
}

.week-box {
    width: 345px;
    background: var(--bg-color-2);
    border-radius: 6px 6px 6px 6px;
    margin: 0 auto 20px;
    color: var(--text-color-2);
}

.week {
    padding-left: 20px;
    font-size: 15px;
    /*border-bottom: 1px solid #000000;*/
    line-height: 51px;
    position: relative;
}

.to-icon {
    width: 16px;
    position: absolute;
    top: 20px;
    right: 12px;
}

.no-tag {
    font-size: 12px;
    text-align: center;
    margin: 30px auto;
    color: var(--text-color-2);
}
</style>




// WEBPACK FOOTER //
// src/views/report/05monthHistory.vue